<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>後派單</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h4 class="col-md-3">搜尋關鍵字:</h4>
        <input
          v-model="kw"
          type="text"
          required="required"
          class="inputstyle col-md-5 fontSize16"
          placeholder="客服姓名、乘客電話、上車地址、備註"
        />
        <button
          @click="onPageChange(1)"
          type="button"
          class="mybtnstyle btn-success"
        >
          搜尋
        </button>
      </div>
      <div class="col-md-5">
        <h4 class="col-md-4">
          <i class="fa fa-user"></i>
          後派單總數:
          <span class="red_textcolor">{{ totalBillAmount }}</span>
        </h4>
      </div>
    </div>
    <div class="x_content move_down">
      <div class="row" style="margin-bottom: 1rem">
        <div class="col-md-1">
          <el-select v-model="paging.npp" @change="onPageChange(1)">
            <el-option
              v-for="npp in [10, 25, 50, 100]"
              :key="npp"
              :label="npp"
              :value="npp"
            />
          </el-select>
        </div>
        <h4>顯示當前未封存的後派單</h4>
      </div>
      <el-table
        :data="list"
        :header-cell-style="tableHeaderColor"
        style="width: 100%"
        stripe
      >
        <el-table-column label="序號" width="50">
          <template slot-scope="scope">
            <span
              style="text-decoration: underline; cursor: pointer; color: blue"
              @click="showNonHailBill(scope.row)"
            >
              {{ (paging.currentPage - 1) * paging.npp + scope.$index + 1 }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" width="180" label="來電時間" />
        <el-table-column prop="passengerPhone" width="100" label="來電電話" />
        <el-table-column prop="reservationTime" width="160" label="預約時間" />
        <el-table-column prop="customerServiceName" label="客服人員" />
        <el-table-column prop="onLocation" label="上車地點" />
        <el-table-column prop="passengerNote" label="備註" />
        <el-table-column prop="cars" label="車輛數" />
        <el-table-column prop="result" label="狀態">
          <template slot-scope="scope">
            <span
              :class="[
                scope.row.result === '未派遣'
                  ? 'red_textcolor'
                  : 'text_hailing',
              ]"
            >
              {{ scope.row.result }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="remindMinute" label="提醒" />
        <el-table-column label="是否處理">
          <template slot-scope="scope">
            <input
              type="checkbox"
              class="flat"
              v-if="isAbnormal(scope.row)"
              @click="updateBill(scope.$index)"
              style="zoom: 180%"
            />
          </template>
        </el-table-column>
        <el-table-column label="派車完畢封存">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="danger"
              @click="deleteBill(scope.$index)"
            >
              派車完畢封存
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--頁籤-->
      <el-row style="margin-top: 1rem">
        <el-col :offset="10">
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="onPageChange"
            :current-page="paging.currentPage"
            :page-count="paging.totalPages"
          />
        </el-col>
      </el-row>
    </div>
    <RecordInfoModal ref="recordInfoModal" @closeRecordModal="getList" />
  </div>
</template>

<script>
import { reqList, reqUpdateState } from '@/api/recordHailBill'
import { orderRemind } from '@/utils/helper'
import { cookies } from '@/utils/cookies'
import dayjs from 'dayjs'
import { MessageBox, Notification, Loading } from 'element-ui'
import RecordInfoModal from '@/components/recordHail/RecordInfoModal'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import Record_behavir from '@/assets/js/libs/FirebaseAPI/RecordBill'
const record = new Record_behavir()

export default {
  name: 'RecordHailBill',
  components: {
    RecordInfoModal,
  },
  data() {
    return {
      kw: '',
      totalBillAmount: 0,
      list: [],
      paging: {
        currentPage: 1,
        totalPages: null,
        npp: 25,
      },
      orderRemindIntervalId: null,
    }
  },
  methods: {
    async getList() {
      const loading = Loading.service()
      try {
        /* BehaviorRecorder.record('點擊', '後派頁面', '提取列表') */
        const { result } = await reqList({
          npp: this.paging.npp,
          page: this.paging.currentPage,
          keyword: this.kw,
        })
        this.list = result.list
        this.totalBillAmount = result.total
        this.paging.totalPages = Math.ceil(
          this.totalBillAmount / this.paging.npp,
        )
      } catch (e) {
        console.error(e)
      } finally {
        loading.close()
      }
    },
    async handleUpdate(payload, listIdx, note) {
      try {
        const { result } = await reqUpdateState(payload)
        record.postRecord({
          type: '後派單派遣',
          event: '更新後派班',
          code: cookies.get('GladTeamCode'),
          id: this.list[listIdx].id,
          note: note,
          user_name: cookies.get('GladName'),
          user_id: '',
        })
        if (note === '封存') {
          Notification({
            type: 'success',
            message: '該單已封存',
          })
        } else {
          Notification({
            type: 'success',
            message: result,
          })
        }
        this.getList()
      } catch (e) {
        console.error(e)
        Notification({
          type: 'error',
          message: `${type}後派單發生異常`,
        })
      }
    },
    deleteBill(listIdx) {
      const bill = this.list[listIdx]
      MessageBox.confirm(
        `<span><b>預約時間:</b> ${bill.reservationTime}</span> <br/> <span><b>上車地址:</b> ${bill.onLocation}</span>`,
        {
          title: '確認要封存後派單嗎?',
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true,
        },
      )
        .then(() => {
          BehaviorRecorder.record(
            '點擊',
            '後派單',
            `封存訂單${this.list[listIdx].id}
預約時間:${this.list[listIdx].reservationTime}
上車地點:${this.list[listIdx].onLocation}`,
          )
          this.handleUpdate({ result: 1, id: bill.id }, listIdx, '封存')
        })
        .catch(() => {
          Notification({
            type: 'info',
            message: '取消封存後派單',
          })
        })
    },
    updateBill(listIdx) {
      BehaviorRecorder.record(
        '點擊',
        '後派單',
        `已處理訂單${this.list[listIdx].id}
預約時間:${this.list[listIdx].reservationTime}
上車地點:${this.list[listIdx].onLocation}`,
      )
      this.handleUpdate(
        { result: 0, id: this.list[listIdx].id },
        listIdx,
        '處理異常',
      )
    },
    onPageChange(page = 1) {
      this.paging.currentPage = page
      this.getList()
    },
    isAbnormal({ reservationTime, remindMinute, state }) {
      try {
        if (state !== null) {
          return false
        } else {
          return dayjs().isAfter(
            dayjs(reservationTime).subtract(remindMinute, 'minutes'),
          )
        }
      } catch (e) {
        console.error(`Error in isAbnormal function : ${e}`)
      }
    },
    tableHeaderColor({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #445465;color: #fff;font-weight: 500;'
      }
    },
    showNonHailBill(row) {
      this.$refs.recordInfoModal.showNonHailBill(row)
    },
  },
  mounted() {
    this.getList()
    this.orderRemindIntervalId = setInterval(() => {
      orderRemind()
    }, 120 * 1000)
  },
  beforeDestroy() {
    clearInterval(this.orderRemindIntervalId)
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/recordHail/RecordHailBill.vue